'use client'
import Link from 'next/link'
import { DigitalData } from '@dustin-web/microsite-components/src/utils/digital-data'
import {
  NavigationEventType,
  NavigationSelectionType,
} from '@dustin-web/microsite-components/src/utils/digital-data-types'

type Props = {
  isAuthenticated: boolean
  text: string
}

const OrderHistoryBtn = ({ isAuthenticated, text }: Props) => {
  if (!isAuthenticated) {
    return null
  }
  const clickHandler = () => {
    DigitalData.pushNavigationInteraction(
      NavigationEventType.MainMenu,
      'order-history',
      'link_click',
      { selectionType: NavigationSelectionType.Orders }
    )
  }
  return (
    <Link onClick={() => clickHandler()} className="c-header__order-history-btn" href="/orders">
      {text}
    </Link>
  )
}

export default OrderHistoryBtn
